import {
    IActionPassData,
    IDatasetFields,
    IFormDataSetContainer,
    IFormItemsControls,
    IFormSavingData,
    IFormStructure
} from '../interface/form-structure';
import {GlobalObjectService} from './global-obj';
import {ISurveySelectedEvent} from '../interface/component';

export interface IFormValidationError {
    field_name: any;
    field_title: string;
    field_id: any;
    error_message: string;
}

export interface IFormValidation {
    validation_status: boolean;
    validation_errors: IFormValidationError[];
}

export class FormSaver {
    formJson: IFormStructure;
    workFlowObjectId: any;
    dataSets: IFormDataSetContainer[];
    fileControlResult: boolean;
    actionPassedData: IActionPassData = null;

    constructor(formJson: IFormStructure, workFlowObjectId: any, fileControl: boolean, actionPassedData: IActionPassData) {
        this.formJson = formJson;
        this.dataSets = formJson.form_json.datasets;
        this.workFlowObjectId = workFlowObjectId;
        this.fileControlResult = fileControl;
        this.actionPassedData = actionPassedData;
    }

    _get_field(fieldName, datasetId): IDatasetFields {
        const dataset = this.dataSets.filter(x => x.dataset_id === datasetId);
        if (dataset.length > 0) {
            const field = dataset[0].fields.filter(y => y.field_name === fieldName);
            if (field.length > 0) {
                return field[0];
            }
        }
        return null;
    }

    public is_selector(datasetId) {
        // Form içinde selector var
        let returnSelector = false;
        this.formJson.form_json.form_json.forEach(form => {
            if (datasetId !== undefined && form.option.dataset_id === datasetId) {
                const isSelect = form.rows.filter(x => x.header.create_or_select !== undefined && x.header.create_or_select === 'select');
                if (isSelect.length > 0) {
                    returnSelector = true;
                }
            }
        });
        return returnSelector;
    }

    public checked_selector(datasetId) {
        let returnSelector = 'create';
        this.formJson.form_json.form_json.forEach(form => {
            if (datasetId !== undefined && form.option.dataset_id === datasetId) {
                const isSelect = form.rows.filter(x => x.header.create_or_select !== undefined && x.header.checked !== undefined
                    && x.header.checked);
                if (isSelect.length > 0) {
                    returnSelector = isSelect[0].header.create_or_select;
                }
            }
        });
        return returnSelector;
    }

    public get_dataset_selector(datasetId) {
        let returnSelector = 'create';
        this.formJson.form_json.form_json.forEach(form => {
            if (datasetId !== undefined && form.option.dataset_id === datasetId) {
                const isSelect = form.rows.filter(x => x.header.create_or_select !== undefined && x.header.checked !== undefined
                    && x.header.checked);
                if (isSelect.length > 0) {
                    returnSelector = isSelect[0].header.create_or_select;
                }
            }
        });
        return returnSelector;
    }

    public validate(): IFormValidation {

        /*
            1- Form Selector kaydı içeriyor mu?
            2 - seçili selector kaydı select değilse
         */

        const responseObject: IFormValidation = {validation_status: false, validation_errors: []};

        this.formJson.form_json.form_json.forEach(x => {
            const isSelector = this.is_selector(x.option.dataset_id); // form selector alanı içeliyor mu?
            const checkedSelector = this.checked_selector(x.option.dataset_id);

            if (!isSelector || (isSelector && checkedSelector === 'create')) {
                x.rows.forEach(y => {
                    const selectType = y.header.create_or_select !== undefined ? y.header.create_or_select : '';// satırın ekleme tipi
                    if (selectType === 'create' || selectType === '') {
                        y.cols.forEach(z => z.controls.forEach(control => {
                            const datasetField = this._get_field(control.name, x.option.dataset_id);

                            if (datasetField != null) {

                                const fieldIsChar = datasetField.field_type.indexOf('character') !== -1
                                    || datasetField.field_type.indexOf('text') !== -1;
                                const fieldIsBool = datasetField.field_type.indexOf('bool') !== -1;
                                const fieldIsForeign = datasetField.field_is_foreign;
                                let fieldIsSetDefault = false;

                                const defaultValue = this.formJson.form_json.defaults.filter(o => o.dataset_id === x.option.dataset_id
                                    && o.field_name === control.name);
                                fieldIsSetDefault = defaultValue.length > 0;

                                // Dataset içinde bu field var.
                                if ((datasetField.field_max_length > 0 && fieldIsChar
                                    && control.defaultValue.toString().length > datasetField.field_max_length)
                                    && !datasetField.is_photo_field) {
                                    if (control.type !== 'file') {
                                        responseObject.validation_errors.push({
                                            field_id: control.id,
                                            field_name: control.name,
                                            field_title: control.label,
                                            error_message: 'Karakter limiti aşıldı. Alan için belirlenen uzunluk '
                                                + datasetField.field_max_length.toString()
                                        });
                                    }
                                }

                                if ((control.requared || datasetField.is_requared) &&
                                    ((fieldIsChar && control.defaultValue.toString().trim() === '')
                                        || (fieldIsForeign && !fieldIsSetDefault && (control.defaultValue.toString().trim() === ''
                                            || control.defaultValue.toString().trim() === '0')))) {
                                    responseObject.validation_errors.push({
                                        field_id: control.id,
                                        field_name: control.name,
                                        field_title: control.label,
                                        error_message: 'Kayıt işleminin gerçekleşmesi için bu alan gerekli.'
                                    });
                                }


                            } else {
                                if (control.requared && control.defaultValue.toString().trim() === '') {
                                    responseObject.validation_errors.push({
                                        field_id: control.id,
                                        field_name: control.name,
                                        field_title: control.label,
                                        error_message: 'Kayıt işleminin gerçekleşmesi için bu alan gerekli.'
                                    });
                                }
                            }


                        }));
                    }
                });
            } else if (isSelector && checkedSelector === 'select') {
                const selectorRows = x.rows.filter(f => f.header.create_or_select === 'select' && f.header.checked);
                if (selectorRows.length > 0 && (x.selectedRecordId === undefined || x.selectedRecordId === 0)) {
                    responseObject.validation_errors.push({
                        field_id: '',
                        field_name: '',
                        field_title: '',
                        error_message: x.header.title + ' için kayıt seçimi yapılmalı!'
                    });
                }
            }
        });

        if (!this.fileControlResult) {
            responseObject.validation_errors.push({
                field_id: '',
                field_name: 'files',
                field_title: 'Dosya Yüklemeleri',
                error_message: 'Kayıt için gerekli dosyalar forma eklenmemiş. Dosyalar butonuna basarak kontrol ediniz!'
            });
        }

        responseObject.validation_status = responseObject.validation_errors.length === 0;
        return responseObject;
    }


    public generateSubmitData() {

        let thousandsSeparatorSymbol = ',';
        let decimalSymbol = '.';

        const setting = GlobalObjectService.getVar('setting');
        if (setting.env.length > 0) {
            decimalSymbol = setting.env[0].decimalSymbol;
            thousandsSeparatorSymbol = setting.env[0].thousandsSeparatorSymbol;
        }
        const formData: IFormSavingData = {
            dataset: [],
            form_data: [],
            filter_operation: []
        };

        let isNotActionField = true;

        let totalPoint = -1;

        this.formJson.form_json.form_json.forEach(formRow => {
            if (formRow.option.dataset_id) {
                totalPoint = -1;
                const datasetData = [];
                const formValueData = [];
                formRow.rows.forEach(y => {
                    y.cols.forEach(z => z.controls.forEach(control => {


                        if (this.actionPassedData !== null && this.actionPassedData !== undefined &&
                            control.name === this.actionPassedData.target_field_name
                            && formRow.option.dataset_id === this.actionPassedData.target_dataset_id) {
                            isNotActionField = false;
                        }

                        let isSave = true;
                        if (control.discardEditList !== undefined) {
                            isSave = !control.discardEditList;
                        }
                        if (isSave) {
                            const datasetField = this._get_field(control.name, formRow.option.dataset_id);
                            let saveValue = control.defaultValue.toString();
                            let saveValue2;

                            if (datasetField !== null) {
                                if (control.type === 'survey') {
                                    saveValue2 = (control.defaultValueTitle as ISurveySelectedEvent[]);
                                    saveValue2.forEach(c => {
                                        c.answers.forEach(t => {
                                            totalPoint += t.point;
                                        });
                                    });
                                }
                                if (datasetField.field_type === 'numeric') {

                                    while (saveValue.indexOf(thousandsSeparatorSymbol) !== -1) {
                                        saveValue = saveValue.replace(thousandsSeparatorSymbol, '');
                                    }
                                    if (decimalSymbol !== '.') {
                                        saveValue = saveValue.replace(decimalSymbol, '.');
                                    }
                                }
                                if (control.suffixControlName && control.suffixControlName !== '') {
                                    datasetData.push({
                                        name: control.suffixControlName, value: control.suffixControlValue
                                    });
                                    formValueData.push({
                                        name: control.suffixControlName, value: control.suffixControlValue
                                    });
                                }
                                datasetData.push({
                                    name: control.name, value: saveValue
                                });

                                if (totalPoint > -1) {
                                    datasetData.push({
                                        name: 'total_point', value: totalPoint
                                    });
                                }

                                if (saveValue2 !== null && saveValue2 !== undefined) {
                                    datasetData.push({
                                        name: 'answer', value: saveValue2
                                    });
                                }

                            }
                            formValueData.push({
                                name: control.name, value: saveValue
                            });
                            formData.filter_operation.push({field: control.name, op: control.options.filterOperation || '='});
                        }

                    }));
                });

                const isDataset = formData.dataset.filter(ds => ds.dataset_id === formRow.option.dataset_id);
                if (isDataset.length > 0) {
                    isDataset[0].data.push(...JSON.parse(JSON.stringify(datasetData)));
                } else {
                    const createOrSelect = this.get_dataset_selector(formRow.option.dataset_id);
                    formData.dataset.push({
                        dataset_id: formRow.option.dataset_id, data: JSON.parse(JSON.stringify(datasetData)),
                        create_or_select: this.get_dataset_selector(formRow.option.dataset_id),
                        select_record_id: createOrSelect === 'select' ? formRow.selectedRecordId : 0
                    });
                }

                const isForm = formData.form_data.filter(ff => ff.form_id === formRow.form_guid);
                if (isForm.length > 0) {
                    isForm[0].data.push(...JSON.parse(JSON.stringify(formValueData)));
                } else {
                    formData.form_data.push({
                        form_id: formRow.form_guid, data: JSON.parse(JSON.stringify(formValueData)),
                        select_record_id: formRow.selectedRecordId
                    });
                }


            } else {
                // dataset yok BOM formu
                const formValueData = [];
                formRow.rows.forEach(y => {
                    y.cols.forEach(z => z.controls.forEach(control => {
                        formValueData.push({
                            name: control.name,
                            value: control.defaultValue,
                            type: control.type,
                            title: control.defaultValueTitle,
                            ext_id: control.options.part_id || 0
                        });

                    }));
                });
                formData.form_data.push({
                    form_id: formRow.master_form_id,
                    data: JSON.parse(JSON.stringify(formValueData)),
                    select_record_id: formRow.selectedRecordId
                });
            }
        });


        if (this.actionPassedData !== null && this.actionPassedData !== undefined && isNotActionField) {
            const datasetControl = formData.dataset.filter(x => x.dataset_id === this.actionPassedData.target_dataset_id);
            if (datasetControl.length > 0) {


                datasetControl[0].data.push({name: this.actionPassedData.target_field_name, value: this.actionPassedData.record_id});

                if (this.actionPassedData.source_dataset_to_query_target_field_name !== '') {
                    datasetControl[0].data.push({
                        name: this.actionPassedData.source_dataset_to_query_target_field_name,
                        value: this.actionPassedData.source_dataset_id
                    });
                }


                if (this.actionPassedData.preQuery !== null && this.actionPassedData.preQuery !== undefined) {
                    console.log('this.actionPassedData.preQuery.forEach:', this.actionPassedData.preQuery);
                    this.actionPassedData.preQuery.forEach(x => {
                        if (x.operator.value !== undefined && x.operator.value === '=') {
                            formData.dataset.forEach(f => {
                                const isFind = f.data.filter(d => d.name === x.field_name);
                                if (isFind.length === 0) {
                                    // daha önce form da alan yok ise !! Var sa belki yeni değer kullanılabilir.
                                    datasetControl[0].data.push({
                                        name: x.field_name,
                                        value: x.value[0].value
                                    });

                                }
                            });


                        }
                    });
                }


            }


        }

        return formData;
    }


}
